import type { ChromeCopy } from './types'

export const en: ChromeCopy = {
  appName: 'Samjho',
  tagline: 'Understand the document. Know your next step.',
  savedTitle: 'Saved documents',
  upcomingTitle: 'Last dates coming up',
  markDone: 'Mark as done',
  doneLabel: 'Done',
  deadlineCheckIn: 'A last date is near for {n} saved paper(s). Done yet?',
  savedHint: 'These are only on this phone. The photo and full text are never saved — only the key details.',
  emptySaved: 'No saved documents yet.',
  clearAll: 'Delete all',
  deleteItem: 'Delete',
  aboutTitle: 'Privacy and important information',
  privacyPoints: [
    'Your document photo and its text are read and explained on this phone. The photo is not uploaded anywhere.',
    'Nothing is saved unless you tap "Save". Tapping "New document" clears the previous document from the screen and memory.',
    'When you save, only the key details (dates, amounts, numbers) are kept, on this phone only — not the photo or full text. You can delete them any time.',
    'The internet is used for only three things: downloading the reading tool and voices (from Samjho\'s own site) the first time, and — only if you ask — translating the document\'s English lines. Lines sent for translation are not stored, and numbers like Aadhaar and phone are removed first. Third, only if you use "Ask": the document\'s text and your question go to the Samjho server and an AI service (Groq) to write the answer, with Aadhaar, PAN, phone and email removed first; only official government websites are looked up, and nothing is saved. Lines that are not in English are translated by an AI service (Groq).',
    'Samjho has no ads. We only count how many people open the app (Cloudflare Web Analytics, no cookies). Nothing from your document is included, and document contents are never logged.'
  ],
  disclaimerTitle: 'This is not official or legal advice',
  disclaimer: 'Samjho is an independent helper tool, not a government website. It simplifies your document, but its explanation is not an official or legal interpretation. Always verify important details with the original document or the issuing authority.',
  contactTitle: 'Having a problem?',
  contact: 'If there is any problem, contact us at:',
  freeTitle: 'Completely free',
  free: 'Samjho runs on open-source tools: Tesseract for reading, and your phone\'s own voice or Meta\'s open MMS voices (CC BY-NC 4.0) for speaking. No account, no payment.',
  shareApp: 'Share on WhatsApp',
  installApp: 'Install app',
  offline: 'You are offline',
  offlineHint: 'If Samjho was used before, documents can still be read without internet.',
  shareAppMessage: 'Understand and listen to official documents in simple language with SAMJHO (free):\nhttps://samjho.pages.dev'
}
